/**
 * 회비 내역 ($j.Ui.JBModal.target 결합) — 기사편집 「회비결제방식」 [내역].
 *
 * 달마다 한 줄 — 그달 방식 · 청구액 · 납부 · 변경사항 (서버 MemberFeeService::history, 최근 10년). DataTables 페이지네이션으로 12개월씩.
 * 예전 [내역]은 이름만 「회비 내역」이고 장기선결제 목록만 보였다 — 월회비가 언제 얼마 나갔는지는 볼 곳이 없었다.
 * 장기선결제 목록 · 환불은 「회비결제방식」 창의 [내역 · 환불](PrepayLog)이 맡는다.
 *
 *   $j.Ui.JBModal.target('fee-history-modal', { target: '$j.F.Admin.Member.FeeHistory', data: { mbNo }, title: '회비 내역', width: '760px' });
 */
import Util from '../../../Common/Util';
export default class FeeHistory {
    destroy() {}

    async init() {
        const $el = $(`#${this.id}`).html('<div class="fh-empty">불러오는 중…</div>');
        let d = null;
        try { d = await $.getJSON(`/adm/ajax/member/${this.data.mbNo}/fee-history`); } catch (e) { /* 아래 안내 */ }
        if (!d || !d.result) { $el.html(`<div class="fh-empty">${this._esc((d && d.message) || '불러오지 못했습니다.')}</div>`); return; }
        const won = (n) => `${Util.formatNumber(n)}원`;
        const rows = d.rows.map((r) => {
            // 선결제 달은 그달 납부가 따로 없다(미리 냈다) — 빈칸 대신 그렇다고 적는다
            const paid = r.paid.length
                ? r.paid.map(([what, n, ok]) => `<div class="${ok ? '' : 'fh-bad'}">${this._esc(what)} ${won(n)}</div>`).join('')
                : (r.way === '선결제' ? '<span class="fh-mute">선결제로 납부</span>' : '');
            return `<tr>
                <td class="fh-c">${r.ym}</td>
                <td class="fh-c">${this._esc(r.way) || '<span class="fh-mute">-</span>'}</td>
                <td class="fh-r">${r.billed === null ? '<span class="fh-mute">-</span>' : won(r.billed)}</td>
                <td class="fh-r">${paid}</td>
                <td>${r.events.map((e) => `<div>${this._esc(e)}</div>`).join('')}</td>
            </tr>`;
        }).join('');
        const tblId = `${this.id}-tbl`;
        $el.html(`${this._style()}<div class="fh">
            <div class="fh-now">지금 방식 <b>${this._esc(d.now)}</b></div>
            <table class="fh-t" id="${tblId}"><thead><tr><th>월</th><th>방식</th><th>청구액</th><th>설명</th><th>변경사항</th></tr></thead>
            <tbody>${rows}</tbody></table>
        </div>`);
        // 관리자 표 공통 페이지네이션(DataTables) — 한 쪽 12개월(1년), 최근 달부터. 검색 · 정렬은 두지 않는다(달 순서가 곧 정렬이다)
        new DataTable(`#${tblId}`, {
            autoWidth: false, searching: false, lengthChange: false, ordering: false, pageLength: 12,
            language: { emptyTable: '회비 내역이 없습니다.' },
        });
    }

    _style() {
        return `<style>
.fh{font-size:12.5px}
.fh-now{margin-bottom:8px}
.fh-t{width:100%;border-collapse:collapse}
.fh-t th{padding:5px 8px;background:var(--adm-surface-soft);border:1px solid var(--adm-border);font-weight:600;white-space:nowrap}
.fh-t td{padding:5px 8px;border:1px solid var(--adm-border);vertical-align:top}
.fh-c{text-align:center;white-space:nowrap}
.fh-r{text-align:right}
.fh-mute{color:var(--adm-text-muted)}
.fh-bad{color:var(--adm-kw-red, red)}
.fh-empty{padding:20px;text-align:center;color:var(--adm-text-muted)}
</style>`;
    }

    _esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }
}
